import React, {Component} from 'react';
import {DatePicker} from 'antd';
import './SATimePicker.css';
import {injectIntl} from "react-intl";
import moment from 'moment';
import Constants from "../../../services/Constants";

import './SADatePicker.css'
import FieldError from "./FieldError";

class SADatePicker extends Component {

  handleOnChange = (date, dateString)=>{
    const {toIsoString} = this.props;
    let value = date;

    if (date && toIsoString === true){
      value = moment(date).format(Constants.DATE_FORMAT_API);
    }
    this.props.onChange(value, dateString);
  }

  render() {
    const {className, error, onChange, value, onDisabledDate, ...attributes} = this.props;
    const errorClassName = error ? " error":'';
    const formattedValue = value ? moment(value, Constants.DATE_FORMAT_API) : null;

    return (
      <span className={className + errorClassName}>
        <DatePicker {...attributes}
          value={formattedValue}
          format={Constants.DATE_FORMAT_DISPLAY}
          onChange={this.handleOnChange}
          disabledDate={onDisabledDate}
        />
        {error && (
          <FieldError error={error}/>
        )}
      </span>
    );
  }
}

export default injectIntl(SADatePicker);
